export default "__VITE_ASSET__d65597f0__"